import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';

// AGENT 16: Initialize Sentry for frontend error monitoring
const sentryDsn = process.env.REACT_APP_SENTRY_DSN || '';
const sentryEnvironment = process.env.REACT_APP_SENTRY_ENVIRONMENT || 'development';

if (sentryDsn && sentryDsn !== 'https://YOUR_SENTRY_DSN_HERE') {
  Sentry.init({
    dsn: sentryDsn,
    environment: sentryEnvironment,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    // Performance Monitoring - sample 10% of transactions
    tracesSampleRate: 0.1,

    // Session Replay - sample 10% of sessions
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors

    // Privacy: Filter sensitive data
    beforeSend(event, hint) {
      // Remove sensitive form data
      if (event.request?.data) {
        const sensitiveFields = ['password', 'token', 'secret', 'api_key', 'slaptazodis'];
        const data = event.request.data as any;

        if (typeof data === 'object') {
          Object.keys(data).forEach(key => {
            if (sensitiveFields.some(field => key.toLowerCase().includes(field))) {
              data[key] = '[REDACTED]';
            }
          });
        }
      }

      return event;
    },
  });

  console.log('✅ Sentry frontend monitoring initialized');
} else {
  console.log('⚠️ Sentry DSN not configured - frontend error monitoring disabled');
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);